module.exports = __webpack_public_path__ + "img/vet_nurse_day_life_splash.f907867b.jpg";